import { Modal } from "components/views/modal/Modal"
import React from "react"
import { BenefitAvailabilityStatus } from "types/benefitEnrollmentStatus"
import DeductibleEnrollmentReminder from "./DeductibleEnrollmentReminder"
import EnrollmentExpiredReminder from "./EnrollmentExpiredReminder"

type EnrollmentReminderProps = {
  availabilityStatus: BenefitAvailabilityStatus
  onExit: () => void
}

const getReminderFromStatus = (
  availabilityStatus: BenefitAvailabilityStatus
): { Component: (props: any) => JSX.Element; title: string } => {
  switch (availabilityStatus) {
    case BenefitAvailabilityStatus.ENROLLMENT_PLAN_EXPIRED:
      return { Component: EnrollmentExpiredReminder, title: "Your Insurance Info Has Expired" }
    case BenefitAvailabilityStatus.COMPANY_ADDED_DEDUCTIBLE:
      return { Component: DeductibleEnrollmentReminder, title: "To access your funds, tell us about your insurance" }
  }
}
const EnrollmentReminder = ({ availabilityStatus, onExit }: EnrollmentReminderProps): JSX.Element => {
  const { Component, title } = getReminderFromStatus(availabilityStatus)
  return (
    <Modal titleText={title} showCloseButton={false}>
      <Component onExit={onExit} />
    </Modal>
  )
}

EnrollmentReminder.displayName = "EnrollmentReminder"

export default EnrollmentReminder
